/*
  JILZARAH — shop engine: the product drawer, add to bag, the confirmation toast
  (COMPONENT layer; built 2026-10-02)

  The retail port of the wholesale shopping engine (../jilzarah-wholesale/assets/
  jilzarah-outlet.js): a shopper opens a product in a side drawer and adds it to the bag
  without leaving the page. Same shape and the same rules as wholesale, minus everything
  B2B: no sign-in gate (retail prices are public), no order minimums or multiples, no stock
  counts in the page, no batch selection, no order bar. Retail words: "bag", not "cart".

  Any page opts in through data attributes; the engine owns no page's markup:

    <script type="application/json" data-jzs-product="<variantId>">   one per product, printed
                                     by snippets/jilzarah-shop-product.liquid
    [data-jzs-detail="<variantId>"]  a link or button that opens the drawer; give a link the
                                     product URL as its href, so it still works without script
    [data-jzs-add="<variantId>"]     a button that adds one to the bag
    [data-jzs-incart="<variantId>"]  shown while that product is in the bag; its
                                     [data-jzs-incart-n] child reads "2 in your bag"
    [data-jzs-view-bag]              opens the store's cart drawer (the cart page without it)
    data-jzs-assets                  on a section's root: asks the layout to load this engine
                                     (snippets/jilzarah-shopping-assets.liquid, which also
                                     renders the drawer, scrim, toast and live region)

  The cart decides, never guessed at: after an add the cart is read again and the toast
  reports what actually landed. Shopify's own refusal text is shown when it refuses.

  Photos open full size in the site's photo viewer (assets/jilzarah-lightbox.js); while it is
  open its keys are its own. While the store's cart drawer is open, its keys are its own.

  Needs window.JZCart (assets/jilzarah-cart.js, identical to wholesale's). No other
  dependencies. Vanilla DOM only.
*/
(function () {
  'use strict';
  if (window.JZShop) return;

  var P = {}, CART = null, busy = false;
  var shell = null, drawer = null, scrim = null, toastEl = null, liveEl = null, toastT = null;
  var dr = { open: false, vid: null, img: 0, qty: 1, adding: null }, lastFocus = null, scrollY = 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAXQ = 20;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function say(t) { if (!liveEl) return; liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = t; }, 30); }
  /* kind: success | error | low — the stylesheet's state colours and shape before the words */
  function toast(html, ms, kind) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    if (kind) toastEl.dataset.kind = kind; else delete toastEl.dataset.kind;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    if (ms !== 0) toastT = setTimeout(function () { toastEl.classList.remove('on'); }, ms || 5000);
  }
  function root() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/?$/, '/'); }
  function cartUrl() { return (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || (root() + 'cart'); }
  function inCart(vid) { return CART ? CART.qty(vid) : 0; }
  var viewBag = function () { return ' <a href="' + esc(cartUrl()) + '" data-jzs-view-bag>View bag</a>'; };
  function priceHtml(p) {
    var sale = p.compareAt > p.price;
    return (sale ? '<span class="visually-hidden">Regular price</span><del>' + esc(p.compareText) + '</del> <span class="visually-hidden">Sale price</span>' : '') + esc(p.priceText);
  }

  /* ---------- writing HTML without losing focus ----------
     When a slot is rewritten while a control inside it has focus, focus goes back to the same
     control, matched by its data-jzs-* attribute (the wholesale engine's put()). If that control
     is gone or cannot take focus, it goes to the nearest one in the slot that can, then to the
     drawer's Close: keyboard focus never falls out to the page. Controls that change state while
     focused (the quantity limits, an add under way) use aria-disabled, never disabled, and the
     quantity is changed in place (updateQty), so most changes rewrite nothing at all. */
  function aria(el, off) { if (!el) return; if (off) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled'); }
  function keyOf(a) {
    if (!a || !a.attributes) return '';
    for (var i = 0; i < a.attributes.length; i++) {
      var at = a.attributes[i];
      if (at.name.indexOf('data-jzs-') === 0) return '[' + at.name + '="' + at.value.replace(/["\\]/g, '\\$&') + '"]';
    }
    return '';
  }
  function put(el, html) {
    if (!el || el.innerHTML === html) return;
    var a = document.activeElement, key = a && el.contains(a) ? keyOf(a) : '';
    el.innerHTML = html;
    if (!key) return;
    var b = el.querySelector(key);
    if (!b || b.disabled) b = el.querySelector('button:not(:disabled), a[href]') || (drawer && drawer.contains(el) ? drawer.querySelector('[data-jzs-close]') : null);
    if (b) b.focus({ preventScroll: true });
  }

  /* ---------- the drawer ---------- */
  function lock(on) {
    if (on) { scrollY = window.scrollY; document.body.style.top = -scrollY + 'px'; document.body.classList.add('jzs-locked'); }
    else { document.body.classList.remove('jzs-locked'); document.body.style.top = ''; window.scrollTo(0, scrollY); }
  }
  function mediaHtml(p) {
    var imgs = p.images || [];
    if (!imgs.length) return '';
    var i = Math.min(dr.img, imgs.length - 1), cur = imgs[i];
    /* the full-size view is the site's photo viewer: the whole gallery, starting at this photo */
    var items = JSON.stringify(imgs.map(function (im) { return { src: im.zoom, w: im.w, h: im.h, alt: im.alt, caption: p.title }; }));
    var html = '<div class="jzs-det__media"><button type="button" class="jzs-det__zoom" data-jz-lightbox data-jz-lb-items="' + esc(items) + '" data-jz-lb-start="' + i + '" aria-label="See the photo full size">' +
      '<img src="' + esc(cur.src) + '" alt="' + esc(cur.alt) + '" width="960" height="960"></button></div>';
    if (imgs.length > 1) {
      html += '<div class="jzs-det__thumbs">' + imgs.map(function (im, j) {
        return '<button type="button" data-jzs-img="' + j + '" aria-current="' + (j === i) + '" aria-label="Photo ' + (j + 1) + ' of ' + imgs.length + '"><img src="' + esc(im.thumb) + '" alt="" width="60" height="60" loading="lazy"></button>';
      }).join('') + '</div>';
    }
    return html;
  }
  function buyHtml(vid) {
    var p = P[vid]; if (!p) return '';
    var control;
    if (!p.available) control = '<button type="button" class="jzs-btn jzs-btn--wide" disabled>Sold out</button>';
    else if (!p.simple) control = '<a class="jzs-btn jzs-btn--secondary jzs-btn--wide" href="' + esc(p.url) + '">Choose options</a>';
    else control = '<div class="jzs-det__ctl">' +
      '<div class="jzs-stp" role="group" aria-label="Quantity">' +
        '<button type="button" data-jzs-dn aria-label="One fewer"' + (dr.qty <= 1 ? ' aria-disabled="true"' : '') + '>&minus;</button>' +
        '<span class="jzs-stp__n" data-jzs-qty>' + dr.qty + '</span>' +
        '<button type="button" data-jzs-up aria-label="One more"' + (dr.qty >= MAXQ ? ' aria-disabled="true"' : '') + '>+</button>' +
      '</div>' +
      '<button type="button" class="jzs-btn" data-jzs-add-drawer="' + esc(vid) + '"' + (dr.adding === vid ? ' aria-disabled="true"' : '') + '>' + (dr.adding === vid ? 'Adding…' : 'Add to bag') + '</button>' +
      '</div>';
    var n = inCart(vid);
    return '<p class="jzs-det__price">' + priceHtml(p) + '</p>' + control +
      (n > 0 ? '<p class="jzs-note" data-kind="success"><span>' + n + ' in your bag</span>' + viewBag() + '</p>' : '');
  }
  function renderDrawer() {
    if (!dr.open || !drawer) return;
    var p = P[dr.vid]; if (!p) return;
    var h = drawer.querySelector('[data-jzs-dr-h]'), body = drawer.querySelector('[data-jzs-dr-body]');
    if (h) h.textContent = p.title;
    if (!body) return;
    put(body,
      mediaHtml(p) +
      '<div class="jzs-det__buy" data-jzs-dr-buy>' + buyHtml(dr.vid) + '</div>' +
      (p.descriptionHtml ? '<div class="jzs-det__desc">' + p.descriptionHtml + '</div>' : '') +
      '<p class="jzs-det__view"><a class="jzs-link" href="' + esc(p.url) + '">View product page</a></p>');
  }
  function updateQty() {
    var buy = drawer && drawer.querySelector('[data-jzs-dr-buy]'); if (!buy) return;
    var n = buy.querySelector('[data-jzs-qty]'); if (n) n.textContent = dr.qty;
    aria(buy.querySelector('[data-jzs-dn]'), dr.qty <= 1);
    aria(buy.querySelector('[data-jzs-up]'), dr.qty >= MAXQ);
  }
  /* the buy area alone: a cart change leaves the photo, the description and the drawer's scroll
     position alone */
  function renderBuy() {
    if (!dr.open || !drawer) return;
    put(drawer.querySelector('[data-jzs-dr-buy]'), buyHtml(dr.vid));
  }
  function openDrawer(vid) {
    if (!drawer || !P[vid]) return false;
    var was = dr.open;
    dr.open = true; dr.vid = vid; dr.img = 0; dr.qty = 1;
    if (!was) { lastFocus = document.activeElement; lock(true); drawer.hidden = false; }
    renderDrawer();
    var body = drawer.querySelector('[data-jzs-dr-body]'); if (body) body.scrollTop = 0;
    if (!was) requestAnimationFrame(function () { drawer.classList.add('on'); if (scrim) scrim.classList.add('on'); });
    setTimeout(function () { var c = drawer.querySelector('[data-jzs-close]'); if (c) c.focus(); }, 40);
    say(P[vid].title + ' opened.');
    return true;
  }
  function closeDrawer() {
    if (!dr.open) return;
    dr.open = false;
    drawer.classList.remove('on'); if (scrim) scrim.classList.remove('on');
    setTimeout(function () { if (!dr.open) drawer.hidden = true; }, reduced ? 0 : 340);
    lock(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- in-your-bag lines on the page ---------- */
  function renderIncart() {
    document.querySelectorAll('[data-jzs-incart]').forEach(function (el) {
      var n = inCart(el.dataset.jzsIncart);
      el.hidden = n <= 0;
      var t = el.querySelector('[data-jzs-incart-n]');
      if (t && n > 0) t.textContent = n + ' in your bag';
    });
  }
  function renderAll() { renderIncart(); renderBuy(); }

  /* ---------- add to bag: one at a time, then the cart decides ----------
     Adds go to the cart one after another, each read back before the next is sent, so every
     confirmation says exactly what landed. Pressing Add on a product while another add is under
     way QUEUES it — it goes in right after, and screen readers hear so — never dropped. Only the
     pressed button changes while its add waits or runs: it says "Adding…" and is marked
     aria-disabled, NOT disabled (a disabled button drops keyboard focus to the page). Pressing
     that same button again meanwhile is the same add, not a second one. Every other button is
     left exactly as the page made it: the engine never disables or re-enables a button it did not
     press, so one a page turned off stays off. (Review fixes, 2026-10-02: the first port disabled
     all 44 Add buttons during any add and silently discarded clicks.) */
  var queue = [];
  function hold(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.jzsLabel = btn.dataset.jzsLabel || btn.textContent; btn.textContent = 'Adding…'; }
    aria(btn, on);
    btn.classList.toggle('jzs-busy', on);
  }
  function add(vid, qty, btn) {
    if (!vid || !(qty >= 1)) return Promise.resolve(null);
    if (btn && btn.classList.contains('jzs-busy')) return Promise.resolve(null); /* already waiting or running */
    return new Promise(function (resolve) {
      var waiting = busy || queue.length > 0;
      queue.push({ vid: String(vid), qty: qty, btn: btn, resolve: resolve });
      hold(btn, true);
      if (waiting) say(((P[vid] && P[vid].title) || 'That item') + ' goes in your bag next.');
      next();
    });
  }
  function next() {
    if (busy || !queue.length) return;
    var job = queue.shift();
    busy = true;
    send(job).then(function (n) { busy = false; job.resolve(n); next(); }, function () { busy = false; hold(job.btn, false); job.resolve(null); next(); });
  }

  /* After an add whose result could not be read back, read the cart again (never add again) a
     few times, 4, 8 and 12 seconds later, until one read works. That read updates every line on
     the page through JZCart, and the theme's header count and cart drawer through refresh().
     JZCart also re-reads when the tab comes back into view. */
  var recheckT = null, rechecks = 0;
  function recheck() {
    clearTimeout(recheckT);
    if (rechecks >= 3) { rechecks = 0; return; }
    recheckT = setTimeout(function () {
      rechecks++;
      CART.load().then(function (cart) { if (cart) { rechecks = 0; CART.refresh(); } else recheck(); });
    }, 4000 * (rechecks + 1));
  }
  function send(job) {
    var vid = job.vid, qty = job.qty, btn = job.btn, p = P[vid];
    var before = inCart(vid), accepted = false, note = '';
    function label() { if (btn && btn.dataset.jzsLabel) btn.textContent = btn.dataset.jzsLabel; }
    return fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +vid, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: false, body: null }; }); })
      .then(function (res) {
        accepted = !!(res.ok && res.body && (res.body.items || res.body.id));
        if (!accepted) { var d = res.body && (res.body.description || res.body.message); note = typeof d === 'string' && d ? d : 'That could not be added.'; }
      }, function () { note = 'We could not reach the bag. Check your connection and try again.'; })
      .then(function () { return CART.load(); })
      .then(function (cart) {
        hold(btn, false);
        var title = (p && p.title) || 'That item', msg;
        if (!cart) {
          msg = accepted
            ? 'Your bag accepted this, but we could not refresh it. Look in your bag to confirm.'
            : 'We could not reach the bag. Check your connection, then look in your bag before adding again.';
          toast('<b>' + esc(msg) + '</b>' + viewBag(), 9000, accepted ? 'low' : 'error'); say(msg);
          label();
          /* the theme reads the cart itself: its header count and drawer may manage where we could not */
          if (accepted) CART.refresh();
          rechecks = 0; recheck();
          return null;
        }
        var added = Math.max(0, inCart(vid) - before);
        if (added > 0) {
          CART.refresh();
          msg = (added > 1 ? added + ' × ' : '') + title + ' added to your bag.';
          if (added < qty) msg = 'Only ' + added + ' of ' + qty + ' could be added. ' + (note || 'That is all there is right now.');
          toast('<b>' + esc(msg) + '</b>' + viewBag(), added < qty ? 9000 : 5000, added < qty ? 'low' : 'success'); say(msg);
          if (btn) {
            btn.textContent = 'Added to bag';
            setTimeout(function () { if (btn.isConnected && !btn.classList.contains('jzs-busy')) label(); }, 1600);
          }
        } else {
          msg = note || 'That may be all there is right now.';
          toast('<b>Not added.</b> ' + esc(msg), 0, 'error'); say('Not added. ' + msg);
          label();
        }
        return added;
      });
  }

  /* ---------- events (one delegated listener each) ---------- */
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b) return;
    var d = b.dataset;
    if (d.jzsDetail !== undefined) { if (openDrawer(d.jzsDetail)) e.preventDefault(); return; }
    if (d.jzsClose !== undefined) { e.preventDefault(); closeDrawer(); return; }
    if (d.jzsImg !== undefined) { dr.img = +d.jzsImg; renderDrawer(); return; }
    if (d.jzsUp !== undefined) { e.preventDefault(); if (dr.qty >= MAXQ) { say(MAXQ + ' is the most at one time.'); return; } dr.qty++; updateQty(); say('Quantity ' + dr.qty); return; }
    if (d.jzsDn !== undefined) { e.preventDefault(); if (dr.qty <= 1) { say('Quantity 1'); return; } dr.qty--; updateQty(); say('Quantity ' + dr.qty); return; }
    if (d.jzsAddDrawer !== undefined) {
      e.preventDefault();
      var avid = d.jzsAddDrawer;
      if (dr.adding === avid) return; /* already waiting or running */
      dr.adding = avid; renderBuy();
      add(avid, dr.qty, null).then(function (n) { if (dr.adding === avid) dr.adding = null; if (n > 0) dr.qty = 1; renderBuy(); });
      return;
    }
    if (d.jzsAdd !== undefined) { e.preventDefault(); add(d.jzsAdd, 1, b); return; }
    if (d.jzsViewBag !== undefined) {
      e.preventDefault();
      if (toastEl) toastEl.classList.remove('on');
      CART.open(function () { if (dr.open) closeDrawer(); });
      return;
    }
  }
  function onKey(e) {
    if (document.documentElement.classList.contains('jz-lb-open')) return; /* the photo viewer's keys */
    if (CART && CART.drawerOpen()) return;                                    /* the cart drawer's keys */
    if (!dr.open || !drawer) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(drawer.querySelectorAll('button:not(:disabled),[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }

  /* ---------- boot: gather products and the shell (idempotent, theme-editor safe) ---------- */
  function scan() {
    document.querySelectorAll('[data-jzs-product]').forEach(function (el) {
      if (el.dataset.jzsRead) return; el.dataset.jzsRead = '1';
      var p; try { p = JSON.parse(el.textContent); } catch (err) { return; }
      if (p && p.variantId) P[String(p.variantId)] = p;
    });
    var s = document.querySelector('[data-jzs-shell]');
    if (s && s !== shell) {
      shell = s; drawer = s.querySelector('[data-jzs-drawer]'); scrim = s.querySelector('[data-jzs-scrim]');
      toastEl = s.querySelector('[data-jzs-toast]'); liveEl = s.querySelector('[data-jzs-live]');
      if (scrim) scrim.addEventListener('click', closeDrawer);
    }
    renderAll();
  }
  function boot() {
    CART = window.JZCart; if (!CART) { setTimeout(boot, 50); return; }
    if (boot.done) { scan(); return; }
    boot.done = true;
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    CART.on(renderAll);
    CART.onError(function (msg) { toast(esc(msg), 0, 'error'); say(msg); });
    scan();
    CART.load();
  }
  window.JZShop = { open: openDrawer, close: closeDrawer, add: add };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
